export default "__VITE_ASSET__D7RWRc6Y__";